import React from "react";
import styled from "styled-components";
import { isMobile } from 'react-device-detect';
import { Link } from "react-router-dom";
import YouTube from 'react-youtube';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faVideo } from "@fortawesome/free-solid-svg-icons";

import Container from "./container"
import Buttons from "./buttons"
import SponsorsListing from "./sponsors-listing"

const FestivalContainer = styled.div`
    display: ${isMobile ? "block":"flex"};
`
const FestivalInfo = styled.section`
    flex-basis: 75%;
    padding-right: 10px;
`
const Content = styled.section`
    margin: 50px 0px;

    p {
        line-height: 2em;
    }
    quote {
        display: block;
        background-color: white;
        color: #666;
        padding: 25px;
        border-radius: 5px;
        font-size: 22px;
        text-align: center;
        font-weight: bold;
        margin: 30px auto;
        width: 70%;
    }
`
const Shows = styled.div`
    > div {
        display: ${isMobile ? "block":"flex"};
        margin-bottom: 25px;

        img {
            width: ${isMobile ? "100%":"200px"};
        }

        > div {
            padding-left: ${isMobile ? 0:15}px;

            h3 {
                margin-top: 0px;
                margin-bottom: 10px;
                color: #ff8500;
                font-size: 25px;
            }

            div.description {
                margin-bottom: 20px;
            }
            div.language {
                font-size: 95%;
                color: #999;
            }
            div.length {
                margin-top: 10px;
            }
            div.trailer {
                margin-top: 15px;
                
                a {
                    text-decoration: none;
                    color: yellow;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
            ul.schedule {
                padding-left: 20px;
            }
        }
    }
`
const Info = styled.div`
    font-size: 22px;
    line-height: ${isMobile ? 1.2:1.6}em;
    margin-bottom: 50px;

    h3 {
        margin-top: ${isMobile ? 15:0}px;
        margin-bottom: 15px;
        text-transform: uppercase;
        font-size: 40px;
        font-weight: bold;
        text-align: ${isMobile ? "center":"left"};
        line-height: 1.25em;

        a {
            text-decoration: none;
            color: white;

            &:hover {
                text-decoration: underline;
            }
        }
        small {
            display: block;
            color: #999;
            margin-top: ${isMobile ? 15:0}px;
        }
    }

    div.download {
        a {
            text-decoration: none;
            color: yellow;

            svg {
                color: white;
            }
            &:hover {
                text-decoration: underline;
            }
        }
    }

    p small {
        line-height: normal;

        img {
            float: right;
            width: ${isMobile ? "100%":"auto"};
        }
    }
`
const Video = styled.section`
  .youtubeContainer {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    overflow: hidden;
    margin-bottom: 50px;
  }
  
  .youtubeContainer iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`
const Schedule = styled.div`
    flex-basis: 25%;
    padding: 0px;

    h3 {
        padding: 10px;
        text-align: center;
        margin-top: 0px;
        text-transform: uppercase;
        border-bottom: 1px solid white;
        font-size: 20px;
        background-color: white;
        color: black;
    }

    ul {
        list-style-type: none;
        padding: 5px;
        margin: 0px;

        h4 {
            text-align: center;
            font-size: 16px;
            margin-bottom: 5px;
            background-color: white;  
            opacity: .8;
            padding: 10px 5px;          
        }

        li {
            text-align: center;
            margin-bottom: 10px;

            div {
                font-weight: bold;
            }
        }
    }
`

function Festival({show}) {
  return (
    <FestivalContainer>
        <FestivalInfo>
            <Info>
                <h3>
                    <Link to={show.url}>
                        {show.title}
                    </Link>
                    {show.subtitle && <small>{show.subtitle}</small>}
                </h3>

                <div className="date">{show.dateFormatted}</div>
                {show.timeFormatted && <div className="time">{show.timeFormatted}</div>}
                {show.location && <div className="location">{show.location}</div>}

                {show.download && 
                    <div className="download">
                        <a href={show.download} target="_blank">
                            <FontAwesomeIcon icon={faFilePdf} />{' '}
                            Download Festival {show.title.toLowerCase().indexOf("international") != -1 ? "Schedule":"Brochure"}
                        </a>
                    </div>
                }

                {show.description && 
                    <p>
                        <small>
                            {show.descriptionImageUrl && 
                                <img src={show.descriptionImageUrl} alt="" />
                            }
                            <div dangerouslySetInnerHTML={{__html: show.description}} />
                        </small>
                    </p>
                }

                <Buttons show={show} tickets /> 
            </Info>

            {(show.content && show.content.length > 0) && 
                <Content dangerouslySetInnerHTML={{__html: show.content}} />
            }
            {show.shows && 
                <Shows>
                {show.shows.map((show, index) => (
                    <div key={index}>
                        <Link to={"/show/" + show.name}>
                            <img src={show.poster} alt={show.title} />
                        </Link>
                        <div>
                            <h3>{show.title}</h3>
                            <div className="description" dangerouslySetInnerHTML={{__html: show.description}} />
                            {show.country && 
                                <div className="country">{show.country}</div>
                            }
                            {show.language && 
                                <div className="language">{show.language}</div>
                            }
                            {show.length && 
                                <div className="length">{show.length}</div>
                            }
                            {show.schedule && 
                                <ul className="schedule">
                                    {show.schedule.map((schedule, index) => (
                                        <li>{schedule}</li>
                                    ))}
                                </ul>
                            }
                            {show.trailer && 
                                <div className="trailer">
                                    <FontAwesomeIcon icon={faVideo} />{' '}
                                    <a href={show.trailer} target="_blank">
                                        Watch Trailer
                                    </a>
                                </div>
                            }
                        </div>                       
                    </div>
                ))}
                </Shows>
            }        
            {show.youtubeVideoId && 
                <Video>
                    <YouTube
                        videoId={show.youtubeVideoId} 
                        containerClassName="youtubeContainer"
                        opts={{
                            height: '390',
                            width: '640',
                            playerVars: {
                            // https://developers.google.com/youtube/player_parameters
                            autoplay: 0,
                            },
                        }}                  
                    />      
                </Video>          
            }
            {(show.sponsors && show.sponsors.length > 0) && 
                <>
                    <br />
                    <br />            
                    <SponsorsListing sponsors={show.sponsors} />
                    <br />
                </>
            }            
        </FestivalInfo>
        {show.schedule && 
            <Schedule style={{backgroundColor: show.backgroundColor}}>
            <h3>Film Schedule</h3>
            <ul>
                {Object.keys(show.schedule).map((day, index) => {
                    const daySchedule = show.schedule[day]

                    return (
                        <li key={index}>
                            <h4 style={{color: show.backgroundColor}}>
                                {day}
                            </h4>
                            <ul>
                                {Object.keys(daySchedule).map((time, index) => {
                                    return (
                                        <li key={index}>
                                            {time}

                                            <div>{daySchedule[time]}</div>
                                        </li>
                                    )
                                })}
                            </ul>
                        </li>
                    )
                })}
            </ul>
        </Schedule>
        }
    </FestivalContainer>    
  );
}

export default Festival;